import { useStore } from "../../store";

export const clearStorageData = () => {
	const clearDeviceInfo = useStore.getState().resetDeviceInfo;
	const clearCustomerInfo = useStore.getState().resetCustomerInfo;
	const clearSessionInfo = useStore.getState().clearSessionInfo;

	clearCustomerInfo();
	clearDeviceInfo();
	clearSessionInfo();
};
